export class FiltroOda {
    impresa?: string;
    bando?: string;
    lotto?: string;
    numero?: number;
  }